import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    code: 'ACCEUIL',
    icon: 'bi bi-house-fill',
    id: 17108,
    label: 'tmw.acceuil.menu-title',
    link: '/'
  },
  {
    code: 'CHARGEMENT',
    icon: 'bi bi-cloud-upload-fill',
    id: 17109,
    label: 'tmw.chargement.menu-title',
    subItems: [
      {
        id: 17110,
        label: 'tmw.chargement.menu.charger-les-fichiers',
        link: '/mej/fichier-annexe',
        parentId: 17109
      },
      {
        id: 17112,
        label: 'tmw.chargement.menu.consulter-ligne-demande',
        link: '/mej/ligne-demande-mej',
        parentId: 17109
      }
    ]
  },
  {
    code: 'MEJ',
    icon: 'bi bi-list-check',
    id: 1711,
    label: 'tmw.mej.menu-title',
    subItems: [
      {
        code: 'MEJ_DEPOSE',
        icon: 'bi bi-diagram-3',
        link: '/mej/demande-mej',
        id: -222,
        label: 'tmw.mej.depose.menu-title',
        parentId: 7109,
      },
      {
        code: 'REGLE_GROUPE',
        access: 'REGLE_GROUPE_VIEW',
        icon: 'bi bi-diagram-3',
        link: '/mej/avis-mej',
        id: 1223,
        label: 'tmw.mej.avis.menu-title',
        parentId: 7109,
      },
      {
        link: '/mej/convocation-comite',
        id: 1223,
        label: 'tmw.mej.avis.menu.panning.comite.title',
        parentId: 7109,
      }
    ],
  },
  {
    code: 'COMMON',
    icon: 'bi bi-database-fill-gear',
    id: 17111,
    label: 'tmw.common.menu-title',
    subItems: [
      {
        code: 'RAPPORT',
        link: '/common/rapport',
        id: 17155,
        label: 'tmw.rapport.menu-title',
        parentId: 17111,
      },
    ],
  },
];
